import { isUserLoggedIn } from "../../utility/utils";
import { Navigate } from "react-router-dom";

const GuestRoutes = [
    {
        path: "login",
        async lazy() {
            const component = await import(
                "../../pages/authentication/Login/Login"
            );
            return {
                Component: () =>
                    isUserLoggedIn() ? (
                        <Navigate to="/" />
                    ) : (
                        <component.default />
                    ),
            };
        },
        exact: true,
    },
    {
        path: "error-404",
        async lazy() {
            const component = await import(
                "../../pages/PageNotFound/PageNotFound"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
    },
    {
        path: "auth/verify",
        async lazy() {
            const component = await import(
                "../../pages/authentication/EmailVerify/EmailVerify"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
    },
    {
        path: "send/verify",
        async lazy() {
            const component = await import(
                "../../pages/authentication/EmailVerification/EmailVerification"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
    },
    {
        path: "access-denied",
        async lazy() {
            const component = await import(
                "../../pages/PageNotFound/AccessDenied"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
    },
];

export default GuestRoutes;
